import React, { Fragment } from 'react';
import './Factbox.scss';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import carouselArrow from '../../assets/carousel_arrow.svg';

function FactboxCarousel({ data, touch }) {
  const sendCarouselClickData = () => {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'carousel_click' });
    }
  };

  const arrowStyles = {
    position: 'absolute',
    zIndex: 3,
    top: 'calc(40%)',
    width: 10,
    height: 16,
    border: 'none',
    padding: 0,
    background: 'transparent',
    cursor: 'pointer'
  };
  const indicatorStyles = {
    background: '#004282',
    width: 12,
    height: 12,
    display: 'inline-block',
    margin: '0 4px',
    borderRadius: '50%',
    cursor: 'pointer'
  };
  return (
    <Carousel
      showStatus={false}
      showThumbs={false}
      showArrows={touch ? false : true}
      renderArrowPrev={(onClickHandler, hasPrev, label) =>
        hasPrev && (
          <button
            type="button"
            onClick={() => {
              onClickHandler();
              sendCarouselClickData();
            }}
            title={label}
            style={{ ...arrowStyles, left: 12 }}
          >
            <img src={carouselArrow} className="factbox__arrows factbox__arrows-left" alt="" />
          </button>
        )
      }
      renderArrowNext={(onClickHandler, hasNext, label) =>
        hasNext && (
          <button
            type="button"
            onClick={() => {
              onClickHandler();
              sendCarouselClickData();
            }}
            title={label}
            style={{ ...arrowStyles, right: 12 }}
          >
            <img src={carouselArrow} className="factbox__arrows" alt="" />
          </button>
        )
      }
      renderIndicator={(onClickHandler, isSelected, index, label) => {
        if (isSelected) {
          return (
            <li
              style={{ ...indicatorStyles, background: '#006BB7' }}
              aria-label={`Selected: ${label} ${index + 1}`}
              title={`Selected: ${label} ${index + 1}`}
            />
          );
        }
        return (
          <li
            style={indicatorStyles}
            onClick={() => {
              onClickHandler();
              sendCarouselClickData();
            }}
            onKeyDown={() => {
              onClickHandler();
              sendCarouselClickData();
            }}
            value={index}
            key={index}
            role="button"
            tabIndex={0}
            title={`${label} ${index + 1}`}
            aria-label={`${label} ${index + 1}`}
          />
        );
      }}
    >
      {data.map(({ year, rate, payment, spent, sales }, i) => {
        return (
          <Fragment key={i}>
            <dl className={'factbox__year factbox__year-carousel'}>
              <h4 className="factbox__year__head">October {year}</h4>
              <dt className="factbox__year__subhead">Average 30-Year Fixed Morgage Rate</dt>
              <dd className="factbox__year__copy">{rate}%</dd>
              <dt className="factbox__year__subhead">Average Monthly Mortgage Payment</dt>
              <dd className="factbox__year__copy">${payment}</dd>
              <dt className="factbox__year__subhead">Existing Home Sales</dt>
              <dd className="factbox__year__copy factbox__year__copy--last">{sales} million</dd>
            </dl>
          </Fragment>
        );
      })}
    </Carousel>
  );
}

export default FactboxCarousel;
